const Hero = () => {
  return (
    <section className="relative w-full overflow-hidden sm:h-[calc(100svh-88px)] sm:min-h-[400px]">
      <img
        src="/image/top.jpeg"
        alt="ヒーロー背景"
        className="w-full h-auto sm:h-full sm:object-cover sm:object-center block"
      />

      {/* テキストコンテンツ：PCは中央+96px、スマホは相対位置で同じ見え方に揃える */}
      <div className="absolute inset-0 z-10 px-4 sm:px-8">
        <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-[70%] sm:top-[calc(50%+6rem)] text-center w-[calc(100%-2rem)] sm:w-auto">
          <div className="inline-block backdrop-blur-sm bg-white/20 rounded-2xl px-4 py-4 sm:px-8 sm:py-7">
            <h2
              className="font-bold text-[#89B56B] text-base sm:text-3xl md:text-4xl lg:text-[42px] xl:text-[52px] sm:whitespace-nowrap"
              style={{ lineHeight: '1.4' }}
            >
              <span className="block">私達はシステムを作る仕事をしていますが、</span>
              <span className="block">同時に人も創っています。</span>
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;